const EventEmitter = require('events');
// const {setAuth} = require('./axiosRequest')
let UserKey = null;
let TokenObj = null;

let emitter = new EventEmitter();


function addRenewEvent(exp) {
    let fireTime = (exp - ((1000 * 60) * 10)) - new Date().getTime();
    if (fireTime >= 1000) {
        setTimeout(() => {
            emitter.emit('refreshToken', null)
        }, fireTime)
    } else {
        emitter.emit('refreshToken', null);
    }
}

module.exports = {

    initialize(tokenObj) {
        UserKey = tokenObj.userKey;
        TokenObj = tokenObj;

        addRenewEvent(tokenObj.exp);
        // setAuth(tokenObj.userKey, tokenObj.token)
    },

    renewToken(tokenObj) {
        TokenObj = tokenObj;

        addRenewEvent(tokenObj.exp)
        // setAuth(tokenObj.userKey, tokenObj.token)
    },

    userKey() {
        return UserKey
    },

    token() {
        return TokenObj === null ? null : TokenObj.token
    },

    valid() {
        return TokenObj === null ? false : TokenObj.exp >= new Date().getTime();
    },

    events: emitter
};
